import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveBreederRolesForUserAction} from '../action';

const tt = t('admin');

function* execute({payload: {userProfileId, breederId}}: RemoveBreederRolesForUserAction): SagaIterator {
    const response = yield* call(Api.endUserProfileBreederRoleBindingForUserProfile, {userProfileId, breederId});

    if (response.isSuccess) {
        yield* put(adminAction.getManagementBreedersTableData(opt({action: 'refresh'}), opt(breederId)));
        yield putAll(showSuccess(
            tt('removeRolesForUser'),
            tt('removeRolesForUserSuccess'),
            false,
            'removeRolesForUser',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeRolesForUser')));
    }
}

/** Runs the admin saga that removes breeder roles from the selected user. */
export function* removeBreederRolesForUserSaga(): SagaIterator {
    yield takeLatestF('admin/REMOVE_BREEDER_ROLES_FOR_USER', execute);
}
